// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"79902d86","168":"01566467","599":"98155e40","625":"8d18ce1e","778":"37f8dc11","787":"067955f4","806":"b8e51793","868":"92cbdf3e","879":"1674b12b","910":"3b41fefe","929":"a25d5adb"}[chunkId] + ".chunk.js";
};